import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Utility
})
export class OtherMergeData {
    @MergeField()
    documentGeneratedDate: string;
}

export const OtherMergeDataSchema = getSchema(OtherMergeData);